import { render, staticRenderFns } from "./subscriptionOrder.vue?vue&type=template&id=3ddf85a6&"
import script from "./subscriptionOrder.vue?vue&type=script&lang=js&"
export * from "./subscriptionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports